import {
  ActionIcon,
  Box,
  Button,
  Center,
  CheckIcon,
  Divider,
  Flex,
  Grid,
  Loader,
  NumberInput,
  Radio,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";

import { usePlaidLink } from "react-plaid-link";

import { IconChevronLeft } from "@tabler/icons-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useStyles } from "./style";

import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { io } from "socket.io-client";
import swal from "sweetalert";
import { socketURL } from "../../http";
import {
  connectCard,
  exchangeToken,
  getConnectedAccounts,
  updateCard,
} from "../../services/payment";
import { getProfile } from "../../services/profile";
import { createSubscription, selectPlan } from "../../services/subscription";
import { validateDiscountCode } from "../../services/discountCode";
import { getCookie, performLogout, showError } from "../../utils";
import { pageInfoAnalytics } from "../../config/mixpanelConfig";
import { CiCreditCard1 } from "react-icons/ci";
import { FaMinus, FaPlus } from "react-icons/fa6";

const PaymentInfo = () => {
  const socket = io(socketURL);
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const newConnect = queryParams.get("connect");
  const { profile } = useSelector((state) => state.profile);
  const isTrialNotUsed = !profile?.user?.isTrialUsed;
  const { classes } = useStyles();
  const location = useLocation();
  const isFreeAccount = location?.state?.isFreeAccount === true;
  const taxDetails = location?.state?.taxDetails || false;

  const [sessionLink, setSessionLink] = useState("");
  const [loadingCalculation, setLoadingCalculation] = useState(false);
  const [connectedLoading, setConnectedLoading] = useState(true);
  const [connected, setConnected] = useState([]);
  const [connectingCard, setConnectingCard] = useState(false);

  let item = state?.plan;
  let monthlyPlan = state?.monthlyPlan;
  let yearlyPlan = state?.yearlyPlan;

  const [selectedPkg, setSelectedPkg] = useState(item || "");
  const [planResponse, setPlanResponse] = useState();
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponMsg, setCouponMsg] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);

  const minimumStaff = Number(selectedPkg?.staff) || 0;
  const [additionalStaffValue, setAdditionalStaffValue] = useState(minimumStaff);

  const staffUnitCost =
    Number(profile?.user?.additionalStaffCost) ||
    Number(selectedPkg?.additionalStaff) ||
    0;

  const extraStaff = Math.max(0, additionalStaffValue - minimumStaff);
  const isAnnual = selectedPkg?.duration === "year";
  const addOnStaffFull = extraStaff * staffUnitCost * (isAnnual ? 12 : 1);
  const addOnDiscountRate = 0.2;
  const addOnStaffPrice = addOnStaffFull * (1 - addOnDiscountRate);

  const basePlanPrice = Number(selectedPkg?.cost);
  const subtotalBeforeDiscount = basePlanPrice + addOnStaffPrice;

  const discountAmount = appliedDiscount
    ? appliedDiscount.discountType === "percentage"
      ? Math.min(
          subtotalBeforeDiscount,
          (subtotalBeforeDiscount * appliedDiscount.discountValue) / 100
        )
      : Math.min(subtotalBeforeDiscount, appliedDiscount.discountValue)
    : 0;

  const totalPrice = Math.max(0, subtotalBeforeDiscount - discountAmount);
  const taxPercentage = Number((planResponse ?? taxDetails)?.taxPercentage || 0);
  const calculatedTaxAmount = (totalPrice * taxPercentage) / 100;
  const totalPriceWithTax = totalPrice + calculatedTaxAmount;

  useEffect(() => {
    setAdditionalStaffValue(minimumStaff);
    setAppliedDiscount(null);
    setCouponCodeValue("");
    setCouponMsg("");
  }, [selectedPkg]);

  const handleSelectPkg = async (pkg, type) => {
    setLoadingCalculation(true);
    setSelectedPkg(pkg);
    const resp = await selectPlan({ id: pkg?.id, billingType: type });
    if (resp?.status === 200) {
      setPlanResponse(resp?.data?.taxDetails);
      setLoadingCalculation(false);
    }
  };

  const form = useForm({
    initialValues: {
      nameCard: "",
      cardNumber: "",
      cardExp: null,
      cardMonth: null,
      cardYear: null,
      CVV: "",
    },
    validate: {
      nameCard: (value) => (value ? null : "Please add card name"),
      cardNumber: (value) =>
        value && value?.length <= 16 ? null : "Please add a valid card number",
      cardMonth: (value) => {
        const isValidLength = value && value.length === 2;
        return isValidLength ? null : "Please add a valid month";
      },
      cardYear: (value) => {
        const isValidLength = value && value.length === 2;
        return isValidLength ? null : "Please add a valid year";
      },
      CVV: (value) => {
        const isValidLength =
          value && (value?.length === 3 || value?.length === 4);
        return isValidLength ? null : "Please add a valid number";
      },
    },
  });

  const config = {
    onSuccess: async (public_token) => {
      let bankData = await exchangeToken({ publicToken: public_token });
      if (bankData) {
        if (newConnect === "true") return navigate("/home/settings");
        getAllConnected();
      }
    },
    onExit: () => {},
    onEvent: (eventName) => {
      if (eventName.includes("EXIT")) {
        // plaid exited
      }
    },
    token: sessionLink,
  };
  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (getCookie("token") && profile) {
      socket.emit("join", profile?.user.id, getCookie("token"));
    }
  }, [getCookie("token")]);

  useEffect(() => {
    socket.on("reconnect", () => {
      if (profile?.user) {
        socket.emit("join", profile?.user?.id, getCookie("token"));
      }
    });

    socket.on("payment-update", (status) => {
      if (status === "payment succeeded") {
        setConnectingCard(false);
        getProfile();
        if (!location.pathname.includes("home/settings"))
          navigate("/payment-success");
        else
          swal("Account changed Successfully", {
            icon: "success",
            buttons: { ok: "Ok" },
          });
      } else if (status?.code === "payment failed") {
        setConnectingCard(false);
        swal("Payment Failed", {
          icon: "error",
          text: `${status?.message}\nPlease ensure your card has enough balance.`,
          buttons: {
            ok: { text: "Go Back", value: "dashboard" },
          },
        }).then((value) => {
          switch (value) {
            case "dashboard":
              performLogout("/");
              break;
            default:
              navigate("/home");
          }
        });
      } else {
        setConnectingCard(false);
      }
    });
  }, []);

  useEffect(() => {
    getAllConnected();
    pageInfoAnalytics("Payment Page Viewed", "Payment Page");
  }, []);

  useEffect(() => {
    if (ready) {
      // plaid ready
    }
  }, [ready, sessionLink]);

  useEffect(() => {
    if (form.getInputProps("cardNumber")?.value?.length > 16) {
      form.setFieldValue(
        "cardNumber",
        form.getInputProps("cardNumber")?.value?.slice(0, 16)
      );
    }
  }, [form.getInputProps("cardNumber")?.value]);

  useEffect(() => {
    if (form.getInputProps("CVV")?.value?.length > 4) {
      form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
    }
  }, [form.getInputProps("CVV")?.value]);

  useEffect(() => {
    if (form.getInputProps("cardMonth")?.value?.length > 2) {
      form.setFieldValue(
        "cardMonth",
        form.getInputProps("cardMonth")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardMonth")]);

  useEffect(() => {
    if (form.getInputProps("cardYear")?.value?.length > 2) {
      form.setFieldValue(
        "cardYear",
        form.getInputProps("cardYear")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardYear")]);

  const getAllConnected = async () => {
    let { accounts } = await getConnectedAccounts();
    const activeAccounts = accounts.filter((account) => account.isActive);
    setConnected(activeAccounts);
    setConnectedLoading(false);
  };

  const buildSubscriptionPayload = (paymentMethod) => {
    let obj = {
      packageId: selectedPkg?.id,
      stripePlanId: selectedPkg?.stripeId,
      email: profile?.user?.email,
      userId: profile?.user.id,
      businessId: profile?.business?.id,
      stripeCustomerId: paymentMethod?.stripeCustomerId,
      susbcriptionType: selectedPkg?.duration,
      taxDetails: taxDetails,
      calculatedTaxAmount: calculatedTaxAmount.toFixed(2),
      totalPriceWithTax: totalPriceWithTax.toFixed(2),
    };

    if (appliedDiscount) {
      obj.discountCode = {
        id: appliedDiscount.id,
        code: appliedDiscount.code,
        discountType: appliedDiscount.discountType,
        discountValue: appliedDiscount.discountValue,
        durationMonths: appliedDiscount.durationMonths,
      };
      obj.discountAmount = discountAmount.toFixed(2);
    }

    if (Number(item?.staff) !== additionalStaffValue) {
      return {
        ...obj,
        isUserChangeAdditionalCount: true,
        customStaffCount: String(additionalStaffValue),
        addOnStaffPrice: String(addOnStaffPrice.toFixed(2)),
        total: planResponse?.subtotal
          ? planResponse.subtotal
          : totalPrice.toFixed(2),
      };
    }

    return obj;
  };

  const onFinish = async (values) => {
    const { cardMonth, cardYear } = values;
    let obj = {
      ...values,
      packageId: selectedPkg?.id,
      stripePlanId: selectedPkg?.stripeId,
      email: profile?.user?.email,
      userId: profile?.user.id,
      businessId: profile?.business?.id,
      cardExp: `${cardMonth}/${cardYear}`,
    };

    delete obj?.cardMonth;
    delete obj?.cardYear;

    setConnectingCard(true);
    try {
      let { accounts } = await getConnectedAccounts();
      const onSuccessPayment = async (stripeCustomerId) => {
        const payload = buildSubscriptionPayload({ stripeCustomerId });
        const resp = await createSubscription(payload, null, "automatic");
        if (resp?.status === 200) {
          setPlanResponse("");
        } else {
          setConnectingCard(false);
          showError(resp || "Something went wrong", 500);
        }
      };
      if (accounts?.length > 0) {
        updateCard(obj, async (error, data) => {
          if (error) {
            setConnectingCard(false);
            swal(
              "Payment failed. Please try another card.",
              `${error || "Something went wrong"}`,
              "error"
            );
            return;
          }
          await onSuccessPayment(data?.stripeCustomer?.id);
          if (newConnect === "true") {
            navigate("/home/settings");
            return;
          }
          getAllConnected();
        });
      } else {
        connectCard(obj, async (error, data) => {
          if (error) {
            setConnectingCard(false);
            swal(
              "Payment failed. Please try another card.",
              `${error || "Something went wrong"}`,
              "error"
            );
            return;
          }
          await onSuccessPayment(data?.stripeCustomer?.id);
          if (newConnect === "true") {
            navigate("/home/settings");
            return;
          }
          getAllConnected();
        });
      }
    } catch (error) {
      setConnectingCard(false);
    }
  };

  const onBack = () => {
    navigate("/skypoint-packages");
    setPlanResponse("");
  };

  return (
    <div className="payment-page">
      <>
        {connectedLoading ? (
          <Center w="100%" mih="100vh">
            <Loader color="yellow" />
          </Center>
        ) : (
          <Flex className={classes.paymentPageBox}>
            <Box className={classes.paymentPageBoxLeft}>
              <Box className={classes.paymentPageBoxLeftInner}>
                {!isFreeAccount && (
                  <UnstyledButton
                    onClick={onBack}
                    className={classes.paymentPageBoxBackBtn}
                  >
                    <IconChevronLeft />
                    Back
                  </UnstyledButton>
                )}
                <img
                  src="assets/images/skypoint-logo2.png"
                  alt=""
                  className={classes.paymentPageBoxLogo}
                />
                <Box className={classes.paymentLeftContent}>
                  <h5 className="hdng">Payment Summary</h5>
                  {/* <p className="subHdng">
                    Get {yearlyPlan ? yearlyPlan?.promotion : ""}% off when you
                    subscribe annually
                  </p> */}
                  {/* <p className="trialPkgNameText">
                    {isTrialNotUsed && selectedPkg?.duration === "month" ? (
                      <>
                        <p className="trialText">2 Weeks free trial</p>&nbsp;(
                        {selectedPkg?.name} Plan)
                      </>
                    ) : (
                      `(${selectedPkg?.name} Plan)`
                    )}
                  </p> */}
                  {monthlyPlan && (
                    <Flex
                      className={`${classes.pkgSelectBox} ${
                        selectedPkg?.id === monthlyPlan?.id
                          ? classes.selectedPkgSelectBox
                          : ""
                      }`}
                      onClick={() => handleSelectPkg(monthlyPlan, "month")}
                    >
                      <Radio
                        icon={CheckIcon}
                        className="radioBtn"
                        checked={selectedPkg?.id === monthlyPlan?.id}
                      />
                      <Box className="pkgInfo">
                        <p className="pkgDurationText">Monthly</p>
                        <p className="pkgPrice">
                          ${monthlyPlan?.cost} / {monthlyPlan?.duration}
                          <span className="staffAndClientCount">
                            ({monthlyPlan?.staff} Staff)
                          </span>
                        </p>
                      </Box>
                    </Flex>
                  )}
                  {yearlyPlan && (
                    <Flex
                      className={`${classes.pkgSelectBox} ${
                        selectedPkg?.id === yearlyPlan?.id
                          ? classes.selectedPkgSelectBox
                          : ""
                      }`}
                      onClick={() => handleSelectPkg(yearlyPlan, "year")}
                    >
                      <Radio
                        icon={CheckIcon}
                        className="radioBtn"
                        checked={selectedPkg?.id === yearlyPlan?.id}
                      />
                      <Box className="pkgInfo">
                        <p className="pkgDurationText">Annual</p>
                        <p className="pkgPrice">
                          ${yearlyPlan?.cost} / {yearlyPlan?.duration}
                          <span className="staffAndClientCount">
                            ({yearlyPlan?.staff} Staff)
                          </span>
                        </p>
                      </Box>
                      <p className="savePer">Save {yearlyPlan?.promotion}%</p>
                    </Flex>
                  )}
                  {item?.name !== "Starter" && (
                    <>
                      {/* <p className={classes.staffAndClientAddSecHdng}>
                        Subscription Add-on
                      </p>
                      <p className={classes.staffAndClientAddSecSubHdng}>
                        Get 20% off if you add more Staff to your subscription
                      </p> */}
                      {/* <Box className={classes.staffAndClientCountBox}>
                        <NumberInput
                          className={classes.outcomeNumberInput}
                          label="Staff"
                          type="number"
                          min={minimumStaff}
                          variant="filled"
                          value={additionalStaffValue}
                          onChange={(value) => {
                            setAdditionalStaffValue(value || minimumStaff);
                          }}
                          icon={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalStaffValue((prev) =>
                                  Math.max(minimumStaff, prev - 1)
                                )
                              }
                            >
                              <FaMinus size={15} color="#000" />
                            </ActionIcon>
                          }
                          rightSection={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalStaffValue((prev) => prev + 1)
                              }
                            >
                              <FaPlus size={15} color="#000" />
                            </ActionIcon>
                          }
                        />
                      </Box> */}
                    </>
                  )}

                  {/* <Flex gap={15} my={20}>
                    <Box className={classes.couponCodeInput}>
                      <TextInput
                        placeholder="Discount Code"
                        className={classes.paymentInputFieldStyle}
                        value={couponCodeValue}
                        disabled={!!appliedDiscount}
                        onChange={(e) => {
                          setCouponCodeValue(e.target.value);
                          setCouponMsg("");
                        }}
                      />
                      {couponMsg && (
                        <p
                          className={classes.validationErrorMsg}
                          style={{ color: appliedDiscount ? "green" : "red" }}
                        >
                          {couponMsg}
                        </p>
                      )}
                    </Box>
                    {appliedDiscount ? (
                      <Button
                        className={[
                          classes.paymentBtn,
                          classes.couponCodeSubmitBtn,
                        ]}
                        color="red"
                        variant="outline"
                        onClick={() => {
                          setAppliedDiscount(null);
                          setCouponCodeValue("");
                          setCouponMsg("");
                        }}
                      >
                        Remove
                      </Button>
                    ) : (
                      <Button
                        className={[
                          classes.paymentBtn,
                          classes.couponCodeSubmitBtn,
                        ]}
                        disabled={!couponCodeValue?.trim() || couponLoading}
                        loading={couponLoading}
                        onClick={async () => {
                          setCouponLoading(true);
                          try {
                            const result = await validateDiscountCode({
                              code: couponCodeValue.trim(),
                              planId: selectedPkg?.id,
                              userId: profile?.user?.id,
                            });
                            if (result?.valid) {
                              setAppliedDiscount(result.discountCode);
                              setCouponMsg(
                                result.discountCode.discountType === "percentage"
                                  ? `${result.discountCode.discountValue}% discount applied!`
                                  : `$${result.discountCode.discountValue} discount applied!`
                              );
                            } else {
                              setCouponMsg(result?.reason || "Invalid Code");
                              setAppliedDiscount(null);
                            }
                          } catch {
                            setCouponMsg("Failed to validate code");
                            setAppliedDiscount(null);
                          }
                          setCouponLoading(false);
                        }}
                      >
                        Apply
                      </Button>
                    )}
                  </Flex> */}

                  {loadingCalculation ? (
                    <Flex justify="center" align="center" my={50}>
                      <Loader color="yellow" />
                    </Flex>
                  ) : (
                    <Box>
                      {/* <Flex className={classes.paymentPriceRow}>
                        <p>Discount Applied</p>
                        <Flex direction="column" align="flex-end" gap={10}>
                          <p
                            style={
                              appliedDiscount
                                ? { color: "green", fontWeight: 600 }
                                : {}
                            }
                          >
                            -${discountAmount.toFixed(2)}
                          </p>
                          {isTrialNotUsed && selectedPkg?.duration === "month" && (
                            <p className="trialText">Free Trial</p>
                          )}
                        </Flex>
                      </Flex> */}
                      <Divider mt={24} mb={24} />
                      <Flex className={classes.paymentPriceRow}>
                        <p>Subscription Plan</p>
                        <p>${selectedPkg?.cost}</p>
                      </Flex>
                      {item?.name !== "Starter" && (
                        <Flex className={classes.paymentPriceRow}>
                          {/* <p>Add-on Staff</p>
                          <p>
                            {addOnStaffFull > 0 &&
                              addOnStaffFull !== addOnStaffPrice && (
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#868e96",
                                    marginRight: 6,
                                    fontSize: "12px",
                                  }}
                                >
                                  ${addOnStaffFull.toFixed(2)}
                                </span>
                              )}
                            ${addOnStaffPrice.toFixed(2)}
                          </p> */}
                        </Flex>
                      )}
                      <Divider mt={16} mb={16} />
                      <Flex direction="column" align="flex-end">
                        <Flex justify="space-between" w="100%">
                          <Text style={{ fontSize: "14px", fontWeight: 500 }}>
                            Due today
                          </Text>
                          <Text style={{ fontSize: "14px", fontWeight: 600 }}>
                            $
                            {isTrialNotUsed && selectedPkg?.duration === "month"
                              ? "0.00"
                              : totalPriceWithTax.toFixed(2)}
                          </Text>
                        </Flex>
                        {isTrialNotUsed && selectedPkg?.duration === "month" && (
                          <Flex direction="column" align="flex-end" mt={6}>
                            {/* <p style={{ fontSize: "12px", color: "#868e96" }}>
                              Amount due after trial
                            </p> */}
                            <p style={{ fontSize: "13px", fontWeight: 600 }}>
                              ${totalPriceWithTax.toFixed(2)}
                            </p>
                          </Flex>
                        )}
                      </Flex>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.paymentPageBoxRight}>
              <form onSubmit={form.onSubmit((values) => onFinish(values))}>
                <h4>
                  <CiCreditCard1 size={34} />
                  Credit or Debit Card
                </h4>
                <div className={classes.inputs}>
                  <TextInput
                    variant="filled"
                    id="name-on-card"
                    label="Name on Card"
                    size="lg"
                    autoComplete="cc-name"
                    placeholder="Eg.abc"
                    {...form.getInputProps("nameCard")}
                    className={classes.paymentInputFieldStyle}
                  />
                </div>
                <div className={classes.inputs}>
                  <TextInput
                    variant="filled"
                    id="card-number"
                    label="Card Number"
                    size="lg"
                    type="number"
                    placeholder="Eg.5952 **** **** ****"
                    {...form.getInputProps("cardNumber")}
                    className={classes.paymentInputFieldStyle}
                  />
                  {form.errors.cardNumber && (
                    <div style={{ color: "red" }}>
                      {form.errors.cardNumber.message}
                    </div>
                  )}
                </div>
                <Grid align="flex-end">
                  <Grid.Col span={4}>
                    <TextInput
                      size="lg"
                      label="MM"
                      type="number"
                      variant="filled"
                      placeholder="MM"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("cardMonth")}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <TextInput
                      size="lg"
                      label="YY"
                      type="number"
                      variant="filled"
                      placeholder="YY"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("cardYear")}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <TextInput
                      size="lg"
                      label="CVV"
                      type="number"
                      variant="filled"
                      placeholder="Eg.***"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("CVV")}
                    />
                  </Grid.Col>
                </Grid>
                <Button
                  id="submit-card"
                  type="submit"
                  loading={connectingCard}
                  className={classes.paymentBtn}
                >
                  Start Free
                  {/* {isTrialNotUsed && selectedPkg?.duration === "month"
                    ? "Start Free Trial"
                    : "Pay Now"} */}
                </Button>
                <p className={classes.agreeTermsCondText}>
                  By subscribing, you agree to our{" "}
                  <Link to="/term-conditions">terms and conditions</Link>.
                </p>
              </form>
            </Box>
          </Flex>
        )}
      </>
    </div>
  );
};

export default PaymentInfo;
